/**
 * useRailCollapsed — collapsed state for the full-page record's right-hand
 * details rail, persisted to localStorage so the user's choice survives
 * refresh (Lightfield-style persistent panel).
 */

import { useCallback, useState } from 'react';

const COLLAPSED_KEY = 'crm-record-rail-collapsed';

function readCollapsed(): boolean {
  try {
    return localStorage.getItem(COLLAPSED_KEY) === 'true';
  } catch {
    return false;
  }
}

export interface RailCollapsedState {
  /** Whether the rail is collapsed (hidden). */
  collapsed: boolean;
  /** Toggle collapsed state (persisted). */
  toggleCollapsed: () => void;
}

export function useRailCollapsed(): RailCollapsedState {
  const [collapsed, setCollapsed] = useState<boolean>(readCollapsed);

  const toggleCollapsed = useCallback(() => {
    setCollapsed(prev => {
      const next = !prev;
      try {
        localStorage.setItem(COLLAPSED_KEY, String(next));
      } catch {
        // ignore persistence failures (private mode, quota, etc.)
      }
      return next;
    });
  }, []);

  return { collapsed, toggleCollapsed };
}
